"use client";

import { useState } from "react";
import { Vehicle } from "../../types/vehicle.types";

interface VehicleOverlayProps {
  vehicles: Vehicle[];
  onSelectVehicle: (vehicle: Vehicle) => void;
  onClose: () => void;
  vehicleLoading: boolean;
}

export function VehicleOverlay({ 
  vehicles, 
  onSelectVehicle, 
  onClose,
  vehicleLoading 
}: VehicleOverlayProps) {
  const [filterText, setFilterText] = useState("");

  const filteredVehicles = vehicles.filter(
    (v) =>
      v.make.toLowerCase().includes(filterText.toLowerCase()) ||
      v.model.toLowerCase().includes(filterText.toLowerCase()) ||
      v.modelYear.toString().includes(filterText) ||
      v.fuelType.toLowerCase().includes(filterText.toLowerCase()) ||
      v.transmission.toLowerCase().includes(filterText.toLowerCase())
  );

  return (
    <div className="vehicle-overlay">
      <div className="vehicle-model-panel">
        <div className="vehicle-model-header">
          <h3 className="vehicle-model-title">Select a Vehicle</h3>
          <button className="close-btn vehicle-model-close-btn" onClick={onClose} aria-label="Close">
            ✕
          </button>
        </div>

        <input
          placeholder="Search vehicles..."
          value={filterText}
          onChange={(e) => setFilterText(e.target.value)}
          className="vehicle-input model-search-input"
        />

        {vehicleLoading ? (
          <div className="emissions-comparison-loading">
            <div 
              className="spinner"
              aria-label = "Vehicle Section Spinner"
            >
            </div>
            <p className="text-white text-center">
              This can sometimes take a few minutes...
            </p>
          </div>
        ) : (

          <div className="vehicle-list">
            {filteredVehicles.length > 0 ? (
              filteredVehicles.map((v) => (
                <div
                  key={v.id}
                  className="vehicle-list-item"
                  onClick={() => onSelectVehicle(v)}
                >
                  <div 
                    className="vehicle-details"
                    aria-label="Select Vehicle"
                  >
                    <strong>{v.make} {v.model} ({v.modelYear})</strong>
                    <p style={{ marginLeft: "1em" }}>• Fuel: {v.fuelType}</p>
                    <p style={{ marginLeft: "1em" }}>• Transmission: {v.transmission}</p>
                    <p style={{ marginLeft: "1em" }}>• Cylinders: {v.cylinders}</p>
                    <p style={{ marginLeft: "1em" }}>• Engine Size: {v.engineSize_L}L</p>
                  </div>
                </div>
              ))
            ) : (
              <p>No vehicles found.</p>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
